module.exports = "../images/drive-in-lodge.svg?v=083e8cd";